/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/8/2016
 * Time: 9:58 AM
 */
export default {
  edit: {
    id: 'employeeLogin.edit',
    description: 'Message for an edit button',
    defaultMessage: 'Edit'
  },
  login: {
    id: 'employeeLogin.login',
    description: 'Message for an login button',
    defaultMessage: 'Login'
  },
  save: {
    id: 'employeeLogin.save',
    description: 'Message for a save button',
    defaultMessage: 'Save'
  },
  cancel: {
    id: 'employeeLogin.cancel',
    description: 'Message for a cancel button',
    defaultMessage: 'Cancel'
  },
  firstName: {
    id: 'employeeLogin.firstName',
    description: 'Descriptive text for first name field',
    defaultMessage: 'First Name'
  },
  firstNamePlaceholder: {
    id: 'employeeLogin.firstName.placeholder',
    description: 'Descriptive text for first name placeholder',
    defaultMessage: 'First Name'
  },
  lastName: {
    id: 'employeeLogin.lastName',
    description: 'Descriptive text for last name field',
    defaultMessage: 'Last Name'
  },
  lastNamePlaceholder: {
    id: 'employeeLogin.lastName.placeholder',
    description: 'Descriptive text for last name placeholder',
    defaultMessage: 'Last Name'
  },
  employeeId: {
    id: 'employeeLogin.employeeId',
    description: 'Descriptive text for employeeId field',
    defaultMessage: 'Employee ID'
  },
  employeeIdPlaceholder: {
    id: 'employeeLogin.employeeId.placeholder',
    description: 'Descriptive text for employeeId placeholder',
    defaultMessage: 'Employee ID'
  },
  email: {
    id: 'employeeLogin.email',
    description: 'Descriptive text for email field',
    defaultMessage: 'Email'
  },
  emailPlaceholder: {
    id: 'employeeLogin.email.placeholder',
    description: 'Descriptive text for email placeholder',
    defaultMessage: 'user@email.com'
  },
  phone: {
    id: 'employeeLogin.phone',
    description: 'Descriptive text for phone field',
    defaultMessage: 'Phone Number'
  },
  phonePlaceholder: {
    id: 'employeeLogin.phone.placeholder',
    description: 'Placeholder for phone input',
    defaultMessage: '(555) 123-4567'
  },
  branchesAssociated: {
    id: 'employeeLogin.branches.associated',
    description: 'A message to display indicating the user is associated with the given branches',
    defaultMessage: 'Associated Branches'
  },
  branchesSelect: {
    id: 'employeeLogin.branches.select',
    description: 'A message to display when a user must select a branch prior to logging in',
    defaultMessage: 'Please select a branch and click login'
  },
  branchesSearch: {
    id: 'employeeLogin.branches.search',
    description: 'Label text for branch search box',
    defaultMessage: 'Branch search'
  },
  branchesSearchPlaceholder: {
    id: 'employeeLogin.branches.search.placeholder',
    description: 'Placeholder text for branch search box',
    defaultMessage: 'Start typing to search...'
  },
  nmlsId: {
    id: 'employeeLogin.nmlsId',
    description: 'Descriptive text for nmlsId field',
    defaultMessage: 'NMLS #'
  },
  nmlsIdPlaceholder: {
    id: 'employeeLogin.nmlsId.placeholder',
    description: 'Descriptive text for nmlsId placeholder',
    defaultMessage: 'NMLS #'
  },
  nmlsIdError: {
    id: 'employeeLogin.errors.nmlsId',
    description: 'Error message for invalid nmlsId',
    defaultMessage: 'Please enter a valid NMLS #'
  },
  firstNameError: {
    id: 'employeeLogin.errors.firstName',
    description: 'Error message for missing First Name',
    defaultMessage: 'First Name is required.'
  },
  lastNameError: {
    id: 'employeeLogin.errors.lastName',
    description: 'Error message for missing Last Name',
    defaultMessage: 'Last Name is required.'
  },
  employeeIdError: {
    id: 'employeeLogin.errors.employeeId',
    description: 'Error message for employeeId',
    defaultMessage: 'Employee ID is required.'
  },
  emailError: {
    id: 'employeeLogin.errors.email',
    description: 'Error message for missing email address',
    defaultMessage: 'A valid email address is required.'
  },
  phoneError: {
    id: 'employeeLogin.errors.phone',
    description: 'Error message for missing phone number',
    defaultMessage: 'A valid 10-digit US phone number is required.'
  },
  employeeBranchesError: {
    id: 'employeeLogin.errors.employeeBranches',
    description: 'Error message when a user is not associated with any branches',
    defaultMessage: 'Please use the branch search box above to add a branch to your profile.'
  },
  search: {
    id: 'employeeLogin.search',
    description: 'Search',
    defaultMessage: 'Search'
  },
  searchText: {
    id: 'employeeLogin.search.description',
    description: 'Helper text that displays on the login dialog.',
    defaultMessage: 'Enter your employee id, name, email address, or phone number to search'
  },
  findProfile: {
    id: 'employeeLogin.search.label',
    description: 'The label for the employee login search box',
    defaultMessage: 'Find an employee profile'
  },
  findProfilePlaceholder: {
    id: 'employeeLogin.search.placeholder',
    description: 'The label for the employee login search box',
    defaultMessage: 'employee id/name/email/phone'
  },
  newProfile: {
    id: 'employeeLogin.newProfile.text',
    description: 'The text to display for the button a user will click to create a new profile.',
    defaultMessage: 'New Profile'
  },
  noProfiles: {
    id: 'employeeLogin.search.empty',
    description: 'A message to display when there are no profiles found.',
    defaultMessage: 'No results found.  Search again or click "New Profile" below to create a profile.'
  },
  profileConflicts: {
    id: 'employeeLogin.search.conflicts',
    description: 'A message to display when there are ID or email conflicts during new profile creation.',
    defaultMessage: 'The following profile(s) were found based on the information you entered.'
  },
  emailConflicts: {
    id: 'employeeLogin.search.conflicts.email',
    description: 'A message to display when there are email address conflicts during new profile creation.',
    defaultMessage: 'Another profile already exists with the same email address.  Please scroll down to choose from one of the existing profiles, or enter a unique value'
  },
  employeeIdConflicts: {
    id: 'employeeLogin.search.conflicts.employeeId',
    description: 'A message to display when there are ID conflicts during new profile creation.',
    defaultMessage: 'Another profile already exists with the same Employee ID.  Please scroll down to choose from one of the existing profiles, or enter a unique value'
  }
};



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/i18n/MessageDefinitions.js
 **/